module.exports = __webpack_public_path__ + "static/ogp-twitter-8728dd9fd2be40d3b07c3077d22ea83c.png";